const tooltipFormParamEquipModel = {
  title: 'clonar tipo de equipo'
};

export default tooltipFormParamEquipModel;
